import { Form } from 'antd';
import React from 'react';
import "./index.less"
const FormItem = ({ FormItemProps, children, ...data }: any) => {
  return <Form.Item className='kx_antd_form_item' {...FormItemProps} {...data}>
    {children}
  </Form.Item>
}

export default FormItem